"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const RowsEditor_vue_1 = __importDefault(require("@/components/RowsEditor.vue"));
const ENABLE_LOGGING = false;
exports.default = vue_1.default.extend({
    name: 'quick',
    props: ['value'],
    data() {
        return {
            item: this.value ? this.value : { row: null, primary_unit: "seconds" },
        };
    },
    methods: {},
    watch: {
        item: {
            handler: function (item) {
                // watch if data has changed and emit changes to parent
                if (item) {
                    this.$emit('input', item);
                }
            },
            immediate: true,
            deep: true
        }
    },
    components: {
        RowsEditor: RowsEditor_vue_1.default,
    }
});
